define(
({
  "select_shipping_method": "Verzendmethode selecteren"
})
);
